/* eslint-disable radix */
/* eslint-disable max-len */
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';
import { theme, toRem } from 'design';

interface ResultsPerPageProps {
  pageSize?: number;
  onChange?: (pageSize: number) => void;
  options?: number[];
  label?: string;
  isLoading?: boolean;
  className?: string;
}

const SELECT_HEIGHT = 27.5;
const SELECT_MARGIN = 22;

const Select = styled.select`
  appearance: none;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  width: auto;
  height: ${toRem(SELECT_HEIGHT)};
  padding: 0 ${toRem(24.75)} 0 ${toRem(11)};
  border-radius: ${toRem(5.5)};
  border: ${toRem(1)} solid ${theme.color.neutral[200]};
  background-color: transparent;
  background-image: url("data:image/svg+xml,%3Csvg width='15' height='14' viewBox='0 0 15 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M3.62976 4.97742C3.79756 4.80961 4.06963 4.80961 4.23743 4.97742L7.80078 8.54077L11.3641 4.97742C11.5319 4.80961 11.804 4.80961 11.9718 4.97742C12.1396 5.14522 12.1396 5.41728 11.9718 5.58508L8.10462 9.45227C7.93681 9.62008 7.66475 9.62008 7.49695 9.45227L3.62976 5.58508C3.46196 5.41728 3.46196 5.14522 3.62976 4.97742Z' fill='%23687081'/%3E%3C/svg%3E%0A");
  background-repeat: no-repeat;
  background-position: 95% 50%;
  font-family: ${theme.font.family.euclid};
  font-weight: ${theme.font.weight.regular};
  font-size: ${toRem(13.25)};
  line-height: 120%;
  color: ${theme.color.neutral[800]};
  cursor: pointer;

  @media (min-width: ${theme.breakpoint.small}px) {
    margin-right: ${toRem(SELECT_MARGIN)};
    border-color: transparent;
  }

  &:hover {
    border-color: ${theme.color.neutral[200]};
  }

  &:focus {
    border-color: ${theme.color.neutral[200]};
    outline: none;
  }
`;

const SelectLoader = styled.span.attrs({ 'aria-hidden': true })`
  position: relative;
  display: flex;
  width: ${toRem(120)};
  height: ${toRem(SELECT_HEIGHT)};
  margin-right: ${toRem(SELECT_MARGIN)};
`;

const StyledSkeleton = styled(Skeleton)`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;

const ResultsPerPage: React.FC<ResultsPerPageProps> = ({ pageSize, onChange, options = [5, 10, 25, 50, 80, 100], label = 'Per Page', isLoading, className }) =>
  isLoading ? (
    <SelectLoader>
      <StyledSkeleton />
    </SelectLoader>
  ) : (
    <Select className={className} value={pageSize} onChange={(event) => onChange && onChange(parseInt(event.target.value))} data-cy="results-per-page-dropdown">
      {options.map((option) => (
        <option data-cy={`results-per-page-dropdown-option-${option}`} key={option} value={option}>
          {`${option} ${label}`}
        </option>
      ))}
    </Select>
  );

export default ResultsPerPage;
